import { Circle } from "js-quadtree"
import { useCallback, useEffect } from "react"
import { useTooltipDataContext } from "./TooltipDataProvider"

export function useTooltipCircle(
  x,
  y,
  radius,
  data = {},
  queryCircleRadius = 4
) {
  const tooltipDataRef = useTooltipDataContext()

  useEffect(() => {
    const scatter = new Circle(x, y, radius, data)

    // insert into provider
    tooltipDataRef.insert(scatter)

    return () => {
      // remove from provider
      tooltipDataRef.remove(scatter)
    }
  }, [tooltipDataRef.lastUpdatedAt, x, y])

  // on mouse over
  const handleMouseOver = useCallback(() => {
    tooltipDataRef.queryCirclePoints(x, y, queryCircleRadius)
  }, [tooltipDataRef.lastUpdatedAt, x, y])

  // on mouse leave
  const handleMouseLeave = useCallback(() => {
    tooltipDataRef.hide()
  }, [tooltipDataRef.lastUpdatedAt])

  return {
    handleMouseLeave,
    handleMouseOver,
    lastUpdatedAt: tooltipDataRef.lastUpdatedAt,
    qt: tooltipDataRef
  }
}
